import { Box, Container, Flex, Grid, Text, Heading } from "@theme-ui/components"
import React from "react"
import { useCompany } from "../hooks/useCompany"
import { useFooter } from "../hooks/useFooter"
import { useLocation } from "../hooks/useLocation"
import { MagicLink } from "../utils/magicLink"
import { useSocial } from "../hooks/useSocial"
import { i18nContext } from "../context/i18nContext"
import { Facebook, Instagram, Twitter, Youtube, Linkedin } from "react-feather"
import HtmlParser from "./htmlParser"
import GreenNumber from "./greenNumber"

const Footer = () => {
  const footer = useFooter()
  const company = useCompany()
  const social = useSocial()
  const locations = useLocation()

  footer.map(footerItem => {
    footerItem.treeChildren.sort((a, b) => a.position - b.position)
    footerItem.treeChildren.map(footerItem => {
      if (footerItem.treeChildren.length > 0) {
        footerItem.treeChildren.sort((a, b) => a.position - b.position)
      }
    })
  })

  return (
    <Box
      as="footer"
      sx={{ backgroundColor: "dark", py: 5, pb: [8, 5], color: "light" }}
    >
      <i18nContext.Consumer>
        {t => (
          <>
            <Container>
              <Grid
                columns={[1, 2, 2, 4]}
                sx={{
                  borderBottom: "1px solid",
                  borderColor: "light",
                  pb: [4],
                }}
              >
                <Box
                  sx={{
                    p: {
                      fontSize: 3,
                      my: [2, 3],
                      "&:first-child": {
                        fontSize: [4],
                        fontWeight: 500,
                        mt: [0],
                        mb: [2, 5],
                        color: "primary",
                      },
                    },
                  }}
                  dangerouslySetInnerHTML={{ __html: company.body }}
                />
                {locations.map((city, index) => (
                  <Box>
                    <Heading
                      as="p"
                      variant="h4"
                      sx={{
                        display: [index === 0 ? "block" : "none", "block"],
                        mb: [2, 5],
                        color: "primary",
                        fontSize: [4],
                        fontWeight: 500,
                        mt: [0],
                      }}
                      dangerouslySetInnerHTML={{
                        __html: index === 0 ? "Visitaci" : "&nbsp;",
                      }}
                    />
                    <Box
                      sx={{
                        backgroundColor: "dark",
                      }}
                    >
                      <HtmlParser html={city.body} theme="dark" />
                    </Box>
                  </Box>
                ))}
              </Grid>
              <Grid columns={[1, 2, 2, 4]} sx={{ pt: [5] }}>
                {footer.map(column => (
                  <List key={column.id}>
                    {column.treeChildren.map(link => (
                      <Item>
                        <Text
                          sx={{ fontWeight: "bold", mb: 2, display: "block" }}
                        >
                          {link.link ? (
                            <MagicLink item={link.link} />
                          ) : (
                            <Heading
                              as="p"
                              variant="h4"
                              sx={{
                                color: "primary",
                                fontSize: [4],
                                fontWeight: 500,
                                mt: [0],
                                mb: [2, 5],
                              }}
                            >
                              {link.anchor}
                            </Heading>
                          )}
                        </Text>
                        <List key={link.id}>
                          {link.treeChildren.map(link => (
                            <Item>
                              {link.link ? (
                                <MagicLink
                                  sx={{ color: "light" }}
                                  item={link.link}
                                />
                              ) : (
                                link.anchor
                              )}
                            </Item>
                          ))}
                        </List>
                      </Item>
                    ))}
                  </List>
                ))}
                <Box>
                  <Heading
                    as="p"
                    variant="h4"
                    sx={{
                      color: "primary",
                      fontSize: [4],
                      fontWeight: 500,
                      mt: [0],
                      mb: [2, 5],
                    }}
                  >
                    Seguici su
                  </Heading>
                  <Flex
                    sx={{
                      display: "flex",
                      py: 1,
                      justifyContent: "space-between",
                      alignContent: "center",
                      flexWrap: "wrap",
                      alignItems: "center",
                    }}
                  >
                    <Box>
                      <Grid columns={[5]} gap={[3]} sx={{ mt: [2, 0] }}>
                        {social.facebook && (
                          <Box>
                            <MagicLink target="_blank" href={social.facebook}>
                              <Facebook color="#FFF" />
                            </MagicLink>
                          </Box>
                        )}
                        {social.twitter && (
                          <Box>
                            <MagicLink target="_blank" href={social.twitter}>
                              <Twitter color="#FFF" />
                            </MagicLink>
                          </Box>
                        )}
                        {social.instagram && (
                          <Box>
                            <MagicLink target="_blank" href={social.instagram}>
                              <Instagram color="#FFF" />
                            </MagicLink>
                          </Box>
                        )}
                        {social.linkedin && (
                          <Box>
                            <MagicLink target="_blank" href={social.linkedin}>
                              <Linkedin color="#FFF" />
                            </MagicLink>
                          </Box>
                        )}
                        {social.youtube && (
                          <Box>
                            <MagicLink target="_blank" href={social.youtube}>
                              <Youtube color="#FFF" />
                            </MagicLink>
                          </Box>
                        )}
                      </Grid>
                    </Box>
                    <Box
                      sx={{
                        span: { color: "primary" },
                        fontWeight: "400",
                        fontSize: [1],
                        pt: [3, 0],
                        fontFamily: "Teko",
                      }}
                      dangerouslySetInnerHTML={{ __html: t.copyright }}
                    ></Box>
                  </Flex>
                </Box>
                <Box>
                  <Heading
                    as="p"
                    variant="h4"
                    sx={{
                      color: "primary",
                      fontSize: [4],
                      fontWeight: 500,
                      mt: [0],
                      mb: [2, 5],
                    }}
                  >
                    Chiamaci
                  </Heading>
                  <GreenNumber />
                </Box>
              </Grid>
            </Container>
            <Container>
              <Text as="p" sx={{ fontSize: [1] }}>
                Socaf S.p.A. - Via Trieste, 14 - 24046 Osio Sotto - BG - Cap.
                Soc. € 1.000.000,00 i.v. – REA BG 197182 – Reg. Imp. BG – Cod.
                Fisc. e Part. IVA IT 01331640167
              </Text>
              <Text as="p" sx={{ fontSize: [1] }}>
                Soggetta alla Direzione e Coordinamento (Art. 2497 bis C.c.) di
                AMA HOLDING SRL CF 04792850168 - Sede Legale: Via Trieste, 14 –
                24046 OSIO SOTTO (BG)
              </Text>
            </Container>
          </>
        )}
      </i18nContext.Consumer>
    </Box>
  )
}

const List = props => {
  return (
    <Flex
      {...props}
      sx={{
        flexDirection: "column",
        margin: 0,
        padding: 0,
        mb: [3, 4],
        listStyle: "none",
        a: {
          textDecoration: "none",
          "&:hover": {
            textDecoration: "underline",
          },
        },
      }}
      as="ul"
    />
  )
}

const Item = props => {
  return <Box {...props} as="li" sx={{ mb: 2, "&:last-child": { mb: 0 } }} />
}

export default Footer
